<template>
  <div class="oferta">
    <div >
      <b-row class="mt-3">
        <b-col>
          <div
            v-if="lang == 'uz_latn'"
           style="padding-left:10vw;padding-right:10vw"
          >
            <div class="privacy-policy-container">
              <header>
                <p  class="text-center" style="font-weight: bold;font-size: 24px;">Maxfiylik siyosati</p>
              </header>

              <main>
                <p>
                  Ushbu Maxfiylik siyosati GovControl.uzdan foydalanganingizda
                  ma'lumotlaringizni to'plash, ishlatish va oshkor qilish
                  bo'yicha siyosat va tartiblarimizni tavsiflaydi va sizga
                  maxfiylik huquqlaringiz va qonun sizni qanday himoya qilishini
                  aytib beradi.
                </p>
                <p>
                  Biz Sizning Shaxsiy ma'lumotlaringizdan Xizmatni taqdim etish
                  va yaxshilash uchun foydalanamiz. Xizmatdan foydalanish orqali
                  siz ushbu Maxfiylik siyosatiga muvofiq ma'lumotlarni to'plash
                  va ishlatishga rozilik bildirasiz.
                </p>

                <section>
                  <p style="font-weight: bold;font-size: 22px;">Sharh va ta'riflar</p>
                  <p style="font-weight: bold;font-size: 18px;">Sharh</p>
                  <p>
                    Bosh harfi bosh harf bilan yozilgan so'zlar quyidagi
                    shartlarda aniqlangan ma'noga ega. Quyidagi ta'riflar
                    birlikda yoki ko'plikda paydo bo'lishidan qat'i nazar, bir
                    xil ma'noga ega bo'lishi kerak.
                  </p>

                  <p style="font-weight: bold;font-size: 24px;">Ta'riflar</p>

                  <p>
                    Ushbu maxfiylik siyosati maqsadlari uchun quyidagi ta'riflar
                    qo'llaniladi:
                  </p>
                  <ul>
                    <li>
                      <strong>Ariza</strong> – Tadbirkorlik subyektlarining
                      huquqlari va qonuniy manfaatlarini himoya qilish bo‘yicha
                      vakil (Biznes-ombudsman) tomonidan taqdim etiladigan
                      GovControl.uz dasturi.
                    </li>

                    <li>
                      <strong>Kompaniya</strong> (shu shartnomada "Kompaniya",
                      "Biz", "Bizning" deb ataladi) – Biznes-ombudsman, 100015,
                      Toshkent shahri, Mirobod tumani, Nukus ko'chasi, 73a-uy.
                    </li>

                    <li><strong>Davlat</strong> - O'zbekiston.</li>

                    <li>
                      <strong>Qurilma</strong> – GovControl.uzga kirishi mumkin
                      bo'lgan barcha qurilmalar.
                    </li>

                    <li>
                      <strong>Shaxsiy ma'lumotlar</strong> - bu aniqlangan yoki
                      aniqlanishi mumkin bo'lgan shaxsga tegishli har qanday
                      ma'lumot.
                    </li>

                    <li><strong>Xizmat</strong> - Ariza.</li>

                    <li>
                      <strong>Xizmat ko'rsatuvchi provayder</strong> –
                      Biznes-ombudsman nomidan ma'lumotlarni qayta ishlovchi har
                      qanday jismoniy yoki yuridik shaxs. GovControl.uzni
                      osonlashtirish, Biznes-ombudsman nomidan GovControl.uz
                      taqdim etish, GovControl.uz bilan bog'liq xizmatlarni
                      bajarish yoki GovControl.uz qanday qo'llanilishini tahlil
                      qilishda yordam berish uchun ishlaydigan shaxslar.
                    </li>
                  </ul>
                </section>

                <section>
                  <p style="font-weight: bold;font-size: 24px;">
                    Sizning shaxsiy ma'lumotlaringizni to'plash va ulardan
                    foydalanish
                  </p>
                  <p style="font-weight: bold;font-size: 22px;">To'plangan ma'lumotlar turlari</p>
                  <p style="font-weight: bold;font-size: 20px;">Shaxsiy ma'lumotlar</p>
                  <p>
                    Xizmatimizdan foydalanishda biz Sizdan Siz bilan bog'lanish
                    yoki shaxsingizni aniqlash uchun ishlatilishi mumkin bo'lgan
                    shaxsiy ma'lumotlarni bizga taqdim etishingizni so'rashimiz
                    mumkin. Shaxsiy identifikatsiya qilinadigan ma'lumotlar
                    quyidagilarni o'z ichiga olishi mumkin, lekin ular bilan
                    cheklanmaydi:
                  </p>
                  <ul>
                    <li>Ism va familiya;</li>

                    <li>Telefon raqami;</li>

                    <li>
                      Manzil, viloyat, indeks/pochta indeksi, shahar;
                    </li>

                    <li>Tadbirkorlik subyektining INN raqami;</li>

                    <li>Tadbirkorlik subyektining nomi.</li>
                  </ul>

                  <p style="font-weight: bold;font-size: 24px;">Shaxsiy ma'lumotlaringizdan foydalanish</p>

                  <p>
                    Biznes-ombudsman shaxsiy ma'lumotlardan quyidagi maqsadlarda
                    foydalanishi mumkin:
                  </p>
                  <ul>
                    <li>Xizmatimizni taqdim etish va saqlash;</li>

                    <li>
                      Sizning so'rovlaringizni boshqarish: Bizga taqdim etilgan
                      so'rovlarni boshqarish uchun.
                    </li>
                  </ul>

                  <p>
                    Biz sizning shaxsiy ma'lumotlaringizni boshqalar bilan baham
                    ko'rmaymiz.
                  </p>

                  <p>
                    <strong>Akkauntni o'chirish:</strong> Shaxsiy
                    ma’lumotlaringizni ilovada "Mening ma’lumotlarim" bo’limida
                    “Akkauntni o‘chirish” tugmasini bosish orqali o’chira
                    olasiz.
                  </p>
                </section>

                <section>
                  <p style="font-weight: bold;font-size: 24px;">Shaxsiy ma’lumotlarni saqlash muddati</p>
                  <ul>
                    <li>
                      Biz Sizning shaxsiy ma’lumotlaringizni faqat ushbu
                      Maxfiylik siyosatida ko‘rsatilgan maqsadlar uchun zarur
                      bo‘lgan muddat davomida yoki amaldagi qonunchilik talab
                      qilgan muddat davomida saqlaymiz.
                    </li>

                    <li>
                      Agar Siz akkauntingizni o‘chirsangiz, shaxsiy
                      ma’lumotlaringiz qonunchilikda belgilangan holatlar bundan
                      mustasno, tizimimizdan o‘chirib tashlanadi.
                    </li>
                  </ul>
                </section>

                <section>
                  <p style="font-weight: bold;font-size: 24px;">Shaxsiy ma’lumotlarni himoyalash choralari</p>
                  <ul>
                    <li>
                      Biz Sizning shaxsiy ma’lumotlaringiz xavfsizligini
                      ta’minlash uchun tegishli texnik va tashkiliy choralarni
                      ko‘ramiz.
                    </li>

                    <li>
                      Bunday choralar ruxsatsiz kirish, yo‘qotish, o‘zgartirish,
                      oshkor qilish yoki noqonuniy foydalanishning oldini
                      olishga qaratilgan.
                    </li>
                  </ul>
                </section>

                <section>
                  <p style="font-weight: bold;font-size: 24px;">Uchinchi shaxslarga ma’lumot uzatish</p>
                  <ul>
                    <li>
                      Biz Sizning shaxsiy ma’lumotlaringizni uchinchi shaxslarga
                      sotmaymiz va ijaraga bermaymiz.
                    </li>

                    <li>
                      Biroq, quyidagi holatlarda ma’lumotlar uchinchi shaxslarga
                      uzatilishi mumkin:
                      <ul>
                        <li>
                          Qonunchilik talablariga muvofiq davlat organlariga;
                        </li>

                        <li>
                          Texnik xizmat ko‘rsatuvchi provayderlarga (server,
                          hosting, texnik qo‘llab-quvvatlash);
                        </li>

                        <li>
                          Xizmatning to‘g‘ri ishlashini ta’minlash uchun zarur
                          bo‘lgan hollarda.
                        </li>
                      </ul>
                    </li>

                    <li>
                      Bunday hollarda ma’lumotlar faqat zarur hajmda uzatiladi.
                    </li>
                  </ul>
                </section>

                <section>
                  <p style="font-weight: bold;font-size: 24px;">Bolalar ma’lumotlari</p>
                  <ul>
                    <li>
                      GovControl.uz 18 yoshga to‘lmagan shaxslarga
                      mo‘ljallanmagan.
                    </li>

                    <li>
                      Biz ongli ravishda 18 yoshga to‘lmagan shaxslardan shaxsiy
                      ma’lumotlarni yig‘maymiz. Agar ota-ona yoki qonuniy vakil
                      voyaga yetmagan shaxs bizga ma'lumot taqdim etganini
                      aniqlasa, biz bilan bog‘lanishi mumkin va bunday
                      ma’lumotlar o‘chirib tashlanadi.
                    </li>
                  </ul>
                </section>

                <section>
                  <p style="font-weight: bold;font-size: 24px;">Foydalanuvchi huquqlari</p>

                  <p>Siz quyidagi huquqlarga egasiz:</p>
                  <ul>
                    <li>Shaxsiy ma’lumotlaringizga kirish;</li>

                    <li>Ularni yangilash yoki to‘g‘rilash;</li>

                    <li>Shaxsiy ma’lumotlaringizni o‘chirish;</li>

                    <li>
                      Shaxsiy ma’lumotlaringizdan foydalanishni cheklash
                    </li>
                  </ul>

                  <p>
                    Ushbu huquqlardan foydalanish uchun biz bilan
                    bog‘lanishingiz mumkin.
                  </p>
                </section>

                <section>
                  <p style="font-weight: bold;font-size: 24px;">Boshqa qonuniy talablar</p>

                  <p>
                    Biznes-ombudsman shaxsiy ma'lumotlarni quyidagi hollarda
                    oshkor qilishi mumkin:
                  </p>
                  <ul>
                    <li>Qonuniy majburiyatga rioya qilish;</li>

                    <li>
                      Biznes-ombudsmanning huquqlari yoki mulkini himoya qilish;
                    </li>

                    <li>
                      Huquqbuzarliklarning oldini olish yoki tekshirish
                    </li>

                    <li>
                      Foydalanuvchilar yoki jamoatchilik xavfsizligini himoya
                      qilish
                    </li>

                    <li>Yuridik javobgarlikdan himoya qilish.</li>
                  </ul>
                </section>

                <section>
                  <p style="font-weight: bold;font-size: 24px;">Boshqa veb-saytlarga havolalar</p>
                  <p>
                    GovControl.uz ilovasi uchun ko’rsatilgan Maxfiylik
                    siyosatiga biz javobgarmiz. Boshqa saytlarga va ulardagi
                    Maxfiylik siyosatiga biz javobgar emasmiz.
                  </p>
                </section>

                <section>
                  <p style="font-weight: bold;font-size: 24px;">Maxfiylik siyosatiga o'zgartirishlar</p>
                  <p>
                    Vaqti-vaqti bilan siyosatni yangilashimiz mumkin. Har qanday
                    o'zgarishlar haqida ushbu sahifada xabardor qilamiz.
                    O'zgartirish kuchga kirishidan oldin elektron pochta va/yoki
                    Xizmatdagi bildirishnoma orqali xabar beramiz.
                  </p>
                </section>

                <section class="contact-box">
                  <p style="font-weight: bold;font-size: 24px;">Biz bilan bog'lanish</p>

                  <p>Savollaringiz bo'lsa:</p>
                  <ul>
                    <li>
                      Email:
                      <a href="mailto:info@biznesombudsman.uz"
                        >info@biznesombudsman.uz</a
                      >
                    </li>

                    <li>
                      Veb-sayt:
                      <a href="https://biznesombudsman.uz" target="_blank"
                        >biznesombudsman.uz</a
                      >
                    </li>
                  </ul>
                </section>
              </main>
            </div>
          </div>
          <div
            v-if="lang == 'uz_cyrl'"
           
            style="padding-left:10vw;padding-right:10vw"
          >
            <div class="privacy-policy-container">
              <header>
                <p class="text-center" style="font-weight: bold;font-size: 24px;">Махфийлик сиёсати</p>
              </header>

              <main>
                <p>
                  Ушбу Махфийлик сиёсати GovControl.uzдан фойдаланганингизда
                  маълумотларингизни тўплаш, ишлатиш ва ошкор қилиш бўйича
                  сиёсат ва тартибларимизни тавсифлайди ва сизга махфийлик
                  ҳуқуқларингиз ва қонун сизни қандай ҳимоя қилишини айтиб
                  беради.
                </p>
                <p>
                  Биз Сизнинг Шахсий маълумотларингиздан Хизматни тақдим этиш ва
                  яхшилаш учун фойдаланамиз. Хизматдан фойдаланиш орқали сиз
                  ушбу Махфийлик сиёсатига мувофиқ маълумотларни тўплаш ва
                  ишлатишга розилик билдирасиз.
                </p>

                <section>
                  <p style="font-weight: bold;font-size: 24px;">Шарҳ ва таърифлар</p>
                  <p style="font-weight: bold;font-size: 20px;">Шарҳ</p>
                  <p>
                    Бош ҳарфи бош ҳарф билан ёзилган сўзлар қуйидаги шартларда
                    аниқланган маънога эга. Қуйидаги таърифлар бирликда ёки
                    кўпликда пайдо бўлишидан қатъи назар, бир хил маънога эга
                    бўлиши керак.
                  </p>

                  <p style="font-weight: bold;font-size: 20px;">Таърифлар</p>

                  <p>
                    Ушбу махфийлик сиёсати мақсадлари учун қуйидаги таърифлар
                    қўлланилади:
                  </p>
                  <ul>
                    <li>
                      <strong>Ариза</strong> – Тадбиркорлик субъектларининг
                      ҳуқуқлари ва қонуний манфаатларини ҳимоя қилиш бўйича
                      вакил (Бизнес-омбудсман) томонидан тақдим этиладиган
                      GovControl.uz дастури.
                    </li>

                    <li>
                      <strong>Компания</strong> (шу шартномада "Компания",
                      "Биз", "Бизнинг" деб аталади) – Бизнес-омбудсман, 100015,
                      Тошкент шаҳри, Миробод тумани, Нукус кўчаси, 73а-у.
                    </li>

                    <li><strong>Давлат</strong> - Ўзбекистон.</li>

                    <li>
                      <strong>Қурилма</strong> – GovControl.uzга кириши мумкин
                      бўлган барча қурилмалар.
                    </li>

                    <li>
                      <strong>Шахсий маълумотлар</strong> - бу аниқланган ёки
                      аниқланиши мумкин бўлган шахсга тегишли ҳар қандай
                      маълумот.
                    </li>

                    <li><strong>Хизмат</strong> - Ариза.</li>

                    <li>
                      <strong>Хизмат кўрсатувчи провайдер</strong> –
                      Бизнес-омбудсман номидан маълумотларни қайта ишловчи ҳар
                      қандай жисмоний ёки юридик шахс. GovControl.uzни
                      осонлаштириш, Бизнес-омбудсман номидан GovControl.uz
                      тақдим этиш, GovControl.uz билан боғлиқ хизматларни
                      бажариш ёки GovControl.uz қандай қўлланилишини таҳлил
                      қилишда ёрдам бериш учун ишлайдиган шахслар.
                    </li>
                  </ul>
                </section>

                <section>
                  <p style="font-weight: bold;font-size: 24px;">
                    Сизнинг шахсий маълумотларингизни тўплаш ва улардан
                    фойдаланиш
                  </p>
                  <p style="font-weight: bold;font-size: 22px;">Тўпланган маълумотлар турлари</p>
                  <p style="font-weight: bold; font-size: 20px;">Шахсий маълумотлар</p>
                  <p>
                    Хизматимиздан фойдаланишда биз Сиздан Сиз билан боғланиш ёки
                    шахсингизни аниқлаш учун ишлатилиши мумкин бўлган шахсий
                    маълумотларни бизга тақдим этишингизни сўрашимиз мумкин.
                    Шахсий идентификация қилинадиган маълумотлар қуйидагиларни
                    ўз ичига олиши мумкин, лекин улар билан чекланмайди:
                  </p>
                  <ul>
                    <li>Исм ва фамилия;</li>

                    <li>Телефон рақами;</li>

                    <li>
                      Манзил, вилоят, индекс/почта индекси, шаҳар;
                    </li>

                    <li>Тадбиркорлик субъектининг ИНН рақами;</li>

                    <li>Тадбиркорлик субъектининг номи.</li>
                  </ul>

                  <p style="font-weight: bold;font-size: 22px;">Шахсий маълумотларингиздан фойдаланиш</p>

                  <p>
                    Бизнес-омбудсман шахсий маълумотлардан қуйидаги мақсадларда
                    фойдаланиши мумкин:
                  </p>
                  <ul>
                    <li>Хизматимизни тақдим этиш ва сақлаш;</li>

                    <li>
                      Сизнинг сўровларингизни бошқариш: Бизга тақдим этилган
                      соўровларни бошқариш учун.
                    </li>
                  </ul>

                  <p>
                    Биз сизнинг шахсий маълумотларингизни бошқалар билан баҳам
                    кўрмаймиз.
                  </p>

                  <p>
                    <strong>Аккаунтни ўчириш:</strong> Шахсий маълумотларингизни
                    иловада "Менинг маълумотларим" бўлимида “Аккаунтни ўчириш”
                    тугмасини босиш орқали ўчира оласиз.
                  </p>
                </section>

                <section>
                  <p style="font-weight: bold;font-size: 24px;">Шахсий маълумотларни сақлаш муддати</p>
                  <ul>
                    <li>
                      Биз Сизнинг шахсий маълумотларингизни фақат ушбу Махфийлик
                      сиёсатида кўрсатилган мақсадлар учун зарур бўлган муддат
                      давомида ёки амалдаги қонунчилик талаб қилган муддат
                      давомида сақлаймиз.
                    </li>

                    <li>
                      Агар Сиз аккаунтингизни ўчирсангиз, шахсий
                      маълумотларингиз қонунчиликда белгиланган ҳолатлар бундан
                      мустасно, тизимимиздан ўчириб ташланади.
                    </li>
                  </ul>
                </section>

                <section>
                  <p style="font-weight: bold;font-size: 24px;">Шахсий маълумотларни ҳимоялаш чоралари</p>
                  <ul>
                    <li>
                      Биз Сизнинг шахсий маълумотларингиз хавфсизлигини
                      таъминлаш учун тегишли техник ва ташкилий чораларни
                      кўрамиз.
                    </li>

                    <li>
                      Бундай чоралар рухсатсиз кириш, йўқотиш, ўзгартириш, ошкор
                      қилиш ёки ноқонуний фойдаланишнинг олдини олишга
                      қаратилган.
                    </li>
                  </ul>
                </section>

                <section>
                  <p style="font-weight: bold;font-size: 24px;">Учинчи шахсларга маълумот узатиш</p>
                  <ul>
                    <li>
                      Биз Сизнинг шахсий маълумотларингизни учинчи шахсларга
                      сотмаймиз ва ижарага бермаймиз.
                    </li>

                    <li>
                      Бироқ, қуйидаги ҳолатларда маълумотлар учинчи шахсларга
                      узатилиши мумкин:
                      <ul>
                        <li>
                          Қонунчилик талабларига мувофиқ давлат органларига;
                        </li>

                        <li>
                          Техник хизмат кўрсатувчи провайдерларга (сервер,
                          хостинг, техник қўллаб-қувватлаш);
                        </li>

                        <li>
                          Хизматнинг тўғри ишлашини таъминлаш учун зарур бўлган
                          ҳолларда.
                        </li>
                      </ul>
                    </li>

                    <li>
                      Бундай ҳолларда маълумотлар фақат зарур ҳажмда узатилади.
                    </li>
                  </ul>
                </section>

                <section>
                  <p style="font-weight: bold;font-size: 24px;">Болалар маълумотлари</p>
                  <ul>
                    <li>
                      GovControl.uz 18 ёшга тўлмаган шахсларга мўлжалланмаган.
                    </li>

                    <li>
                      Биз онгли равишда 18 ёшга тўлмаган шахслардан шахсий
                      маълумотларни йиғмаймиз. Агар ота-она ёки қонуний вакил
                      вояга етмаган шахс бизга маълумот тақдим этганини
                      аниқласа, биз билан боғланиши мумкин ва бундай маълумотлар
                      ўчириб ташланади.
                    </li>
                  </ul>
                </section>

                <section>
                  <p style="font-weight: bold;font-size: 24px;">Фойдаланувчи ҳуқуқлари</p>

                  <p>Сиз қуйидаги ҳуқуқларга эгасиз:</p>
                  <ul>
                    <li>Шахсий маълумотларингизга кириш;</li>

                    <li>Уларни янгилаш ёки тўғрилаш;</li>

                    <li>Шахсий маълумотларингизни ўчириш;</li>

                    <li>
                      Шахсий маълумотларингиздан фойдаланишни чеклаш
                    </li>
                  </ul>

                  <p>
                    Ушбу ҳуқуқлардан фойдаланиш учун биз билан боғланишингиз
                    мумкин.
                  </p>
                </section>

                <section>
                  <p style="font-weight: bold;font-size: 24px;">Бошқа қонуний талаблар</p>

                  <p>
                    Бизнес-омбудсман шахсий маълумотларни қуйидаги ҳолларда
                    ошкор қилиши мумкин:
                  </p>
                  <ul>
                    <li>Қонуний мажбуриятга риоя қилиш;</li>

                    <li>
                      Бизнес-омбудсманнинг ҳуқуқлари ёки мулкини ҳимоя қилиш;
                    </li>

                    <li>
                      Ҳуқуқбузарликларнинг олдини олиш ёки текшириш
                    </li>

                    <li>
                      Фойдаланувчилар ёки жамоатчилик хавфсизлигини ҳимоя қилиш
                    </li>

                    <li>Юридик жавобгарликдан ҳимоя қилиш.</li>
                  </ul>
                </section>

                <section>
                  <p style="font-weight: bold;font-size: 24px;">Бошқа веб-сайтларга ҳаволалар</p>
                  <p>
                    GovControl.uz иловаси учун кўрсатилган Махфийлик сиёсатига
                    биз жавобгармиз. Бошқа сайтларга ва улардаги Махфийлик
                    сиёсатига биз жавобгар эмасмиз.
                  </p>
                </section>

                <section>
                  <p style="font-weight: bold;font-size: 24px;">Махфийлик сиёсатига ўзгартиришлар</p>
                  <p>
                    Вақти-вақти билан сиёсатни янгилашимиз мумкин. Ҳар қандай
                    ўзгаришлар ҳақида ушбу саҳифада хабардор қиламиз. Ўзгартириш
                    кучга киришидан олдин электрон почта ва/ёки Хизматдаги
                    билдиришнома орқали хабар берамиз.
                  </p>
                </section>

                <section class="contact-box">
                  <p style="font-weight: bold;font-size: 24px;">Биз билан боғланиш</p>

                  <p>Саволларингиз бўлса:</p>
                  <ul>
                    <li>
                      Email:
                      <a href="mailto:info@biznesombudsman.uz"
                        >info@biznesombudsman.uz</a
                      >
                    </li>

                    <li>
                      Веб-сайт:
                      <a href="https://biznesombudsman.uz" target="_blank"
                        >biznesombudsman.uz</a
                      >
                    </li>
                  </ul>
                </section>
              </main>
            </div>
          </div>
          <div
            v-if="lang == 'ru'"
            style="padding-left:10vw;padding-right:10vw"
          >
            <div class="privacy-policy-container">
              <header>
                <p class="text-center" style="font-weight: bold;font-size: 24px;">ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ</p>
              </header>

              <main>
                <p>
                  Настоящая Политика конфиденциальности описывает наши правила и
                  процедуры по сбору, использованию и раскрытию информации при
                  использовании GovControl.uz, а также информирует вас о ваших
                  правах на конфиденциальность и о том, как закон защищает вас.
                </p>
                <p>
                  Мы используем ваши Персональные данные для предоставления и
                  улучшения Сервиса. Используя Сервис, вы соглашаетесь на сбор и
                  использование информации в соответствии с настоящей Политикой
                  конфиденциальности.
                </p>

                <section>
                  <p style="font-weight: bold;font-size: 24px;">Толкование и определения</p>
                  <p style="font-weight: bold;font-size: 22px;">Толкование</p>
                  <p>
                    Слова, написанные с заглавной буквы, имеют значения,
                    определенные при следующих условиях. Следующие определения
                    имеют одинаковое значение независимо от того, используются
                    ли они в единственном или множественном числе.
                  </p>

                  <p style="font-weight: bold;font-size: 22px;">Определения</p>
                  <p>
                    Для целей настоящей Политики конфиденциальности применяются
                    следующие определения:
                  </p>
                  <ul>
                    <li>
                      <strong>Приложение</strong> — программа GovControl.uz,
                      предоставляемая Уполномоченным по защите прав и законных
                      интересов субъектов предпринимательства
                      (Бизнес-омбудсмен).
                    </li>
                    <li>
                      <strong>Компания</strong> (именуемая в настоящем документе
                      как «Компания», «Мы», «Нас» или «Наш») — Бизнес-омбудсмен,
                      100015, Республика Узбекистан, город Ташкент, Мирободский
                      район, улица Нукус, дом 73а.
                    </li>
                    <li>
                      <strong>Государство</strong> — Республика Узбекистан.
                    </li>
                    <li>
                      <strong>Устройство</strong> — любое устройство, с которого
                      возможен доступ к GovControl.uz.
                    </li>
                    <li>
                      <strong>Персональные данные</strong> — любая информация,
                      относящаяся к идентифицированному или идентифицируемому
                      физическому лицу.
                    </li>
                    <li><strong>Сервис</strong> — Приложение.</li>
                    <li>
                      <strong>Поставщик услуг</strong> — любое физическое или
                      юридическое лицо, которое обрабатывает данные от имени
                      Бизнес-омбудсмена, предоставляет услуги GovControl.uz,
                      выполняет сервисные функции или помогает анализировать
                      использование GovControl.uz.
                    </li>
                  </ul>
                </section>

                <section>
                  <p style="font-weight: bold;font-size: 24px;">Сбор и использование ваших персональных данных</p>
                  <p style="font-weight: bold;font-size: 22px;">Виды собираемых данных</p>
                  <p style="font-weight: bold; font-size: 20px;">Персональные данные</p>
                  <p>
                    При использовании нашего Сервиса мы можем попросить вас
                    предоставить определённую персональную информацию, которая
                    может быть использована для связи с вами или вашей
                    идентификации. К персональным данным относятся, в том числе,
                    но не исключительно:
                  </p>
                  <ul>
                    <li>Имя и фамилия</li>
                    <li>Номер телефона</li>
                    <li>Адрес, область, почтовый индекс, город</li>
                    <li>ИНН субъекта предпринимательства</li>
                    <li>Наименование субъекта предпринимательства</li>
                  </ul>

                  <p style="font-weight: bold; font-size: 20px;">Данные, собираемые при использовании Приложения</p>
                  <p>
                    При использовании нашего Приложения, с вашего
                    предварительного согласия, мы можем собирать информацию,
                    включая данные о вашем местоположении. Мы используем эти
                    данные для предоставления, улучшения и настройки нашего
                    Сервиса.
                  </p>
                  <p>
                    Вы можете в любое время включить или отключить доступ к этим
                    данным через настройки вашего устройства.
                  </p>
                </section>

                <section>
                  <p style="font-weight: bold;font-size: 24px;">Использование персональных данных</p>
                  <p>
                    Бизнес-омбудсмен может использовать персональные данные для
                    следующих целей:
                  </p>
                  <ul>
                    <li>Предоставление и поддержка работы Сервиса.</li>
                    <li>Управление вашими обращениями и запросами.</li>
                  </ul>
                  <p>Мы не передаем ваши персональные данные третьим лицам.</p>
                  <p>
                    <strong>Удаление данных:</strong> Вы можете удалить свои
                    персональные данные в разделе «Мои данные» Приложения, нажав
                    кнопку <strong>«Удалить аккаунт»</strong>.
                  </p>
                </section>

                <section>
                  <p style="font-weight: bold;font-size: 24px;">Иные правовые требования</p>
                  <p>
                    Бизнес-омбудсмен может раскрыть ваши персональные данные,
                    если это необходимо для:
                  </p>
                  <ul>
                    <li>Соблюдения требований законодательства</li>
                    <li>Защиты прав или собственности Бизнес-омбудсмена</li>
                    <li>
                      Предотвращения или расследования возможных правонарушений
                    </li>
                    <li>
                      Обеспечения личной безопасности пользователей или
                      общественности
                    </li>
                    <li>Защиты от юридической ответственности</li>
                  </ul>
                </section>

                <section>
                  <p style="font-weight: bold;font-size: 24px;">Ссылки на другие веб-сайты</p>
                  <p>
                    GovControl.uz может содержать ссылки на другие веб-сайты,
                    которые не управляются нами. Мы не несем ответственности за
                    политику конфиденциальности сторонних сайтов.
                  </p>
                </section>

                <section>
                  <p style="font-weight: bold;font-size: 24px;">Изменения в настоящей Политике</p>
                  <p>
                    Мы можем периодически обновлять настоящую Политику
                    конфиденциальности. Обо всех изменениях мы будем уведомлять
                    вас путем размещения новой редакции на данной странице и
                    через уведомления в Сервисе до вступления изменений в силу.
                  </p>
                </section>

                <section class="contact-box">
                  <p style="font-weight: bold;font-size: 24px;">Связь с нами</p>
                  <p>
                    Если у вас есть вопросы по настоящей Политике
                    конфиденциальности:
                  </p>
                  <ul>
                    <li>
                      Email:
                      <a href="mailto:info@biznesombudsman.uz"
                        >info@biznesombudsman.uz</a
                      >
                    </li>
                    <li>
                      Веб-сайт:
                      <a href="https://biznesombudsman.uz" target="_blank"
                        >biznesombudsman.uz</a
                      >
                    </li>
                  </ul>
                </section>
              </main>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";
export default {
  components: { BRow, BCol },

  data() {
    return {
      lang: localStorage.getItem("locale") || "uz_cyrl",
    };
  },
  methods: {
    ReturnRegister() {
      this.$router.push({ name: "Register" });
    },
  },
};
</script>

<style scoped>
.privacy-policy {
  font-family: "Inter", sans-serif;
  line-height: 1.6;
  color: #334155;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}
h1 {
  color: #0f172a;
  border-bottom: 2px solid #e2e8f0;
  padding-bottom: 10px;
}
h2 {
  color: #1e293b;
  margin-top: 25px;
  font-size: 1.5rem;
}
ul {
  padding-left: 20px;
}
li {
  margin-bottom: 8px;
}
.contact-section {
  background: #f8fafc;
  padding: 20px;
  border-radius: 8px;
  margin-top: 30px;
  border-left: 4px solid #3b82f6;
}
</style>
